import { Injectable } from '@angular/core';
import { LocalStoreService } from '../LocalStoreService/local-store.service';

const USER_KEY = 'auth-user';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  constructor(private ls: LocalStoreService) {}

  clean(): void {
    window.sessionStorage.clear();
  }

  public saveUser(user: any): void {
    window.sessionStorage.removeItem(USER_KEY);
    window.sessionStorage.setItem(USER_KEY, JSON.stringify(user));
  }

  public saveOrigem(origem: any): void {
    window.sessionStorage.removeItem("origem");
    window.sessionStorage.setItem("origem", origem);
  }

  public getOrigem(): any {
    const origem = window.sessionStorage.getItem("origem");
    if (origem) {
      return origem;
    }
    return null;
  }

  public getUser(): any {
    const user = window.sessionStorage.getItem(USER_KEY);
    if (user) {
      return JSON.parse(user);
    }

    return null;
  }

  public isLoggedIn(): boolean {
    const user = window.sessionStorage.getItem(USER_KEY);
    if (user) {
      return true;
    }

    return false;
  }

  public logout() {
    window.sessionStorage.clear();
    window.localStorage.clear();
    window.sessionStorage.removeItem(USER_KEY);
  }
}
